import { ProductEntityDetailDto } from '@/api/backoffice/clients';

export const productEntityLabel = (detail: ProductEntityDetailDto) => {
    return `${detail.code} (${detail.label})`;
};

export const copyProductEntityValues = (from: ProductEntityDetailDto, to: ProductEntityDetailDto) => {
    if (from?.id === to?.id) {
        to.code = from.code;
        to.label = from.label;
        to.description = from.description;
        to.crs = from.crs;
        to.model = from.model;
    }
};
